import useIsEmbed from '@embed/useIsEmbed';
import { createPortal } from 'react-dom';

const Modal = ({
  theme = 'light', children, className, ...property
}) => {
  const isEmbed = useIsEmbed();

  // This is a bare backdrop + arbitrary (often hand-sized, fixed-width) child
  // content, unlike @atoms/new/modal which owns its own box. In embeds this
  // renders as a plain DOM descendant of the zoomed #ppt-stage, and `zoom`
  // (unlike `transform`) scales fixed-position descendants too — so the
  // backdrop and its child would shrink/grow with the slide zoom instead of
  // rendering at native, readable scale. Portal to document.body to escape
  // it entirely; the child's own fixed width can then overflow a small pane,
  // which `.embed-modal-backdrop > div` (globals.css) clamps generically
  // since we don't own the child markup here.
  const modal = (
    <div className={`fixed backdrop-filter overflow-y-auto inset-0 z-50 ${theme === 'light' ? 'bg-modalBg backdrop-blur-30' : 'bg-black bg-opacity-50'} [&>div]:animate-slideUp top-0 bottom-0 right-0 left-0 ${isEmbed ? 'embed-modal-backdrop' : ''} ${className}`} {...property}>
      {children}
    </div>
  );

  return isEmbed && typeof document !== 'undefined'
    ? createPortal(modal, document.body)
    : modal;
};

export default Modal;
